import SimpleTable2 from "components/Tables/SimpleTable2"
import { useAPI } from "hooks/useAPI"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
  Spinner,
} from "reactstrap"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const DashboardTable = props => {
  const REPORT_ID = 19

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )

  const { payload, error, isLoading } = useAPI(
    REPORT_ID,
    filtrosSelecionados,
    fetchReports
  )

  const [anoEscolhido, setAnoEscolhido] = useState(0)

  const { data, faixas, status } = payload

  const report =
    data?.filter(d => d?.range == faixas[anoEscolhido])?.[0] || null

  const heads = [
    {
      classNames: "text-center table-primary",
      ths: [{ cell: "Status" }],
    },
  ]

  let firstDate = moment(faixas?.[anoEscolhido], "MM/YYYY").startOf("month")

  const lastDate = moment(firstDate).endOf("month")

  while (firstDate.isSameOrBefore(lastDate)) {
    heads[0].ths.push({ cell: firstDate.format("DD") })
    firstDate.add(1, "day")
  }
  heads[0].ths.push({ cell: "Total Geral" })

  let bodies = []

  if (report) {
    let dailyTotal = new Array(heads[0]?.ths?.length - 2).fill(0)
    status?.map(s => {
      bodies.push({ tds: [{ cell: s?.name }] })
      let firstDate = moment(faixas?.[anoEscolhido], "MM/YYYY").startOf("month")
      const lastDate = moment(firstDate).endOf("month")
      const filteredStatus = report?.values?.filter(v => v?.statusId == s?.id)
      let tot = 0
      let idx = 0
      while (firstDate.isSameOrBefore(lastDate)) {
        const found = filteredStatus.find(v =>
          moment(
            `${v?.day}-${String(v?.month).padStart(2, "0")}-${v?.year}`,
            "DD-MM-YYYY"
          ).isSame(firstDate)
        )
        bodies[bodies?.length - 1]?.tds.push({
          classNames: "text-center",
          cell: found ? Intl.NumberFormat("pt-BR").format(found?.value) : "",
        })
        tot += found ? found?.value : 0

        firstDate.add(1, "day")
        dailyTotal[idx] += found ? found?.value : 0
        idx += 1
      }
      bodies[bodies?.length - 1].tds.push({
        classNames: "text-center",
        cell: tot ? Intl.NumberFormat("pt-BR").format(tot) : "",
      })
    })
    bodies.push({ tds: [{ cell: "Total Diário" }] })
    dailyTotal.forEach(d => {
      bodies[bodies?.length - 1].tds.push({
        classNames: "text-center",
        cell: d ? Intl.NumberFormat("pt-BR").format(d) : "",
      })
    })
    const allTotal = dailyTotal.reduce((acc, cur) => {
      return acc + cur
    }, 0)
    bodies[bodies?.length - 1].tds.push({
      classNames: "text-center",
      cell: allTotal > 0 ? Intl.NumberFormat("pt-BR").format(allTotal) : "",
    })
  }

  return (
    <Card>
      <CardHeader tag={"h5"} className="bg-transparent border-bottom">
        <Row className="hstack">
          <Col>Visão Safra - Tabela</Col>
          {isLoading ? (
            <Col>
              <Spinner className="ms-2 float-end" color="secondary" />
            </Col>
          ) : (
            faixas?.length > 0 && (
              <Col>
                <Input
                  className="form-control-sm float-end"
                  type="select"
                  style={{ width: "150px" }}
                  onChange={e => {
                    setAnoEscolhido(e.target.value)
                  }}
                >
                  {faixas.map((item, idx) => {
                    return (
                      <option key={idx} value={idx}>
                        {item}
                      </option>
                    )
                  })}
                </Input>
              </Col>
            )
          )}
        </Row>
      </CardHeader>
      <CardBody>
        {!isLoading ? (
          report ? (
            <Row>
              <SimpleTable2
                isLoading={isLoading}
                tableClasses={"table-responsive"}
                tableInnerClasses={"table-striped table-bordered table-sm"}
                tHeads={heads}
                tBodies={bodies}
              />
            </Row>
          ) : (
            <Row>
              <div className="text-center pt-3">
                <h6>Nenhum dado foi encontrado.</h6>
              </div>
            </Row>
          )
        ) : (
          <div className="mt-3" style={{ textAlign: "center" }}>
            <Spinner className="ms-2" color="primary" />
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default DashboardTable
